import React from 'react';
import { Radiobox, Text } from '@topconagriculture/react-components';
import { Form, Field } from 'react-final-form';
import { FormControlLabel, Grid, Radio, FormControl } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useWidgetUpdateConfigMutation } from '../../../../hooks';
import { ModalActionButton, ModalActions, useModal, useModalTitle } from '@topconagriculture/modal';
import { makeStyles } from '@material-ui/core/styles';
import { WidgetSize } from '../../widget.types';
const useStyles = makeStyles(() => ({
    title: {
        textTransform: 'capitalize',
    },
    form: {
        minWidth: 300,
        padding: '20px 0 20px 20px',
        '& button': {
            '& span': {
                justifyContent: 'right',
            },
        },
    },
    footer: {
        marginTop: 20,
    },
}));
export const ChangeSizeForm = () => {
    const { closeModal, modalParams: { widget }, } = useModal();
    const { t } = useTranslation();
    const updateWidgetMutation = useWidgetUpdateConfigMutation();
    const classes = useStyles();
    useModalTitle(t(widget.title));
    const onSubmit = (values) => {
        const uuid = widget.uuid;
        updateWidgetMutation.mutate({ uuid, config: { size: values.size } });
        closeModal();
    };
    return (React.createElement(Form, { onSubmit: onSubmit, render: ({ handleSubmit, values }) => (React.createElement("form", { id: "inventory-widget", className: classes.form, onSubmit: handleSubmit },
            React.createElement(Text, { className: classes.title, block: true, size: 16 }, t('widget:drive:size')),
            React.createElement(FormControl, null,
                React.createElement(Field, { name: "size", defaultValue: widget.config.size, component: Radiobox, type: "radio" },
                    React.createElement(Grid, { container: true, direction: "row" },
                        React.createElement(FormControlLabel, { key: WidgetSize.XS, value: WidgetSize.XS, checked: values.size === WidgetSize.XS, control: React.createElement(Radio, null), label: "XS" }),
                        React.createElement(FormControlLabel, { key: WidgetSize.S, value: WidgetSize.S, checked: values.size === WidgetSize.S, control: React.createElement(Radio, null), label: "S" }),
                        React.createElement(FormControlLabel, { key: WidgetSize.L, value: WidgetSize.L, checked: values.size === WidgetSize.L, control: React.createElement(Radio, null), label: "L" })))),
            React.createElement("div", { className: classes.footer },
                React.createElement(ModalActions, { closeModal: closeModal },
                    React.createElement(ModalActionButton, { action: handleSubmit, btnLabel: t('common:save') }))))) }));
};
//# sourceMappingURL=ChangeSizeForm.js.map